/* External */
import React from 'react';

import PropTypes from 'prop-types';

/* Ott-common */
import Icon from '@dtvgo/icon';

/* Styles */
import './RewindTimeButton.scss';
// import { useIntl } from 'react-intl';
import PlayerButton from '../PlayerButton/PlayerButton';

function RewindTimeButton({
  showButton = true,
  handleRewind,
  tooltip = '',
  className = '',
}) {
  // const { formatMessage } = useIntl();

  if (showButton) {
    return (
      <PlayerButton
        className={`dtv-common-c-rewindtime-button ${className}`}
        onClick={handleRewind}
        tooltip={tooltip}

      >
        <div className="dtv-rewindtime-content-button">
          <Icon name="rewind10" />
          {/* <div className="dtv-rewindtime-tooltip">
            {formatMessage({ id: 'player.backward30' })}
          </div> */}
        </div>
      </PlayerButton>
    );
  }

  // eslint-disable-next-line unicorn/no-null -- React doesn't support returning undefined
  return null;
}

RewindTimeButton.propTypes = {
  showButton: PropTypes.bool,
  handleRewind: PropTypes.func,
  tooltip: PropTypes.string,
  className: PropTypes.string,
};

RewindTimeButton.defaultProps = {
  showButton: true,
  handleRewind: () => {},
  tooltip: '',
  className: '',
};

export default RewindTimeButton;
